// extracted by mini-css-extract-plugin
module.exports = {"HeaderAuth":"HeaderAuth_HeaderAuth__wa7AD","LoginBtn":"HeaderAuth_LoginBtn__1Sdjt","UserBtn":"HeaderAuth_UserBtn__gWTXE","Menu":"HeaderAuth_Menu__i9zhk"};